import Bowser from 'bowser';
import { getRecaptcha } from './recaptcha';
import { mount } from '../dom-lifecycle';

mount('[data-receipt-file-upload]', function () {
    const $container = $(this);
    const $input = $container.find('[data-ref=input]');
    const $dataPreview = $container.find('[data-ref=data-preview]');
    const $scannerModal = $container.find('[data-ref=scanner-modal]');
    const $scannerContainer = $container.find('[data-ref=scanner-container]');
    const $loaderModal = $container.find('[data-ref=loader-modal]');

    // Numer i data paragonu pokazują się dopiero po wgraniu zdjęcia (Figma:
    // pusty formularz 142:411 ich nie ma, wypełniony 160:4986 już tak). Chowamy
    // je przez `disabled` na <fieldset>, a nie klasą — wyłączone pola nie
    // blokują walidacji HTML5 formularza, więc niewidoczne wymagane pole nie
    // zatrzyma wysyłki w sposób niewidoczny dla użytkownika
    // (`fieldset:disabled { display: none }` — assets/styles/generic.scss).
    //
    // Ukrywamy je TUTAJ, a nie w szablonie, bo to konsekwencja obecności
    // skanera: przy RECEIPT_API_ENABLED=false ten komponent nie istnieje
    // i pola zostają widoczne do wpisania ręcznie.
    const $billRows = $(this.form ?? $container.closest('form')).find('.c-form__row--bill');
    $billRows.prop('disabled', true);

    $input.on('change', async function () {
        $container.find('[name=receiptUuid]').remove();
        $container.find('.file-error').remove();

        const file = this.files[0];
        if (!file) {
            return;
        }
        const formData = new FormData();
        formData.set('file', file);
        //formData.set('g-recaptcha-response', await getRecaptcha());
        formData.set('_token', $(this).data('token'));
        formData.set('wsUuid', await getWebsocketUuid());

        // Przebieg analizy pokazujemy w modalu, nie pod polem — okno otwieramy
        // przed nawiązaniem WebSocketa, żeby złapać komunikaty od pierwszego.
        $dataPreview.empty();
        $loaderModal.modal('show');
        openWebSocket(formData.get('wsUuid'));

        try {
            var data = await $.ajax({
                type: 'POST',
                url: $(this).data('url'),
                data: formData,
                processData: false,
                contentType: false,
            });
        } catch (xhr) {
            const errors = xhr.responseJSON?.errors;
            const defaultMessage = 'Wystąpił nieznany błąd, proszę spróbować jeszcze raz.';
            const message = errors ? Object.values(errors).flat().join('<br>') : defaultMessage;
            $(this).closest('.form-group').append(`<div class="invalid-feedback d-block file-error">${message}</div>`)
            return;
        } finally {
            $loaderModal.modal('hide');
        }
        $container.append(`<input type="hidden" name="receiptUuid" value="${data.receiptUuid}">`);
        // Odsłaniamy pola PRZED wypełnieniem, żeby maski (imask) i datepicker
        // działały na widocznych, włączonych polach.
        $billRows.prop('disabled', false);
        for (let name in data.billData) {
            $(`input[name="personal_data[${name}]"]`).val(data.billData[name]).trigger('input');
        }
    });

    function getWebsocketUuid() {
        return fetch($input.data('ws-uuid-url'))
            .then(response => response.json())
            .then(data => data.uuid)
            .catch(() => {});
    }

    function openWebSocket(uuid) {
        var ws = new WebSocket($input.data('ws-url'));
        ws.onmessage = data => { 
            $dataPreview.html($dataPreview.html() + data.data.replace('\n', '<br />'));
            $dataPreview.scrollTop($dataPreview[0].scrollHeight);
        };
        ws.onopen = () => ws.send(JSON.stringify({ uuid: uuid }));
    }

    $input.on('click', function (e) {
        if (['mobile', 'tablet'].includes(Bowser.parse(navigator.userAgent).platform.type)) {
            e.preventDefault();

            $scannerModal.modal('show');
        }
    });

    $scannerModal.on('show.bs.modal', function () {
        const scannerUrl = $input.data('scanner-url');

        // Rozmiar z CSS-a (`.c-scanner__frame iframe`), nie ze stylu inline —
        // bazowe `min-height: 90dvh` zostawiało nad i pod ramką pasek tła modala.
        $scannerContainer.append(
            `<iframe src="${scannerUrl}" allow="camera; microphone"></iframe>`
        );
    });

    $scannerModal.on('hide.bs.modal', function () {
        if (window.innerWidth < 992) {
            $scannerContainer.find('iframe').remove();
        }
    });

    window.addEventListener('message', function(event) {
        let scannerData;

        try {
            scannerData = JSON.parse(event.data);
        } catch (e) {
            scannerData = null;
        }

        if (scannerData && scannerData?.name === 'scannerImage') {
            let file = dataURLtoFile(scannerData.data, `receipt-${Date.now()}.png`);
            let container = new DataTransfer();
            container.items.add(file);
            $input.prop('files', container.files).trigger('change');
            $scannerModal.modal('hide');
        }
    });
});

function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
}